<article class="alert w-100" role="alert" [ngClass]="'bg-' + status">
  <h2 class="type-body-sm font-secondary fw-bold mb-2" *ngIf="title">{{ title }}</h2>
  <p class="mb-0" *ngIf="message">{{ message }}</p>

  <ng-content></ng-content>
</article>
